import axios from 'axios';
import Split from '../split/Split';
import { resolveId } from '../../utils';
import { getUsersQuery } from './queries';
import { buildLoopbackQuery, buildExpressQuery } from './queries/builders';

const getUser = (id, fields) =>
    new Promise((resolve, reject) => {
        const queryBuilder = Split.getBooleanTreatment('use_express_auth_endpoints') ? buildExpressQuery : buildLoopbackQuery;
        const userQuery = getUsersQuery({ ids: [id], fields, queryBuilder });
        const userRequest = axios.get(userQuery);
        userRequest
            .then((userResponse) => {
                // Express returns _id instead of id — normalize so downstream
                // code that relies on user.id works consistently.
                resolve(resolveId(userResponse.data[0]));
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to process request'));
            });
    });

export default getUser;
